/**
 *  Generate password
 *
 * @param {Number} length - password length
 * @return {String} - Password
 */

export default function generatePassword (length = 6) {
  let password = '';
  let characterSet = 'abcdefghjkmnpqrstuvwxyzABCDEFGHJKMNPQRSTUVWXYZ23456789';

  for (let i = 0; i < length; i++) {
    password += characterSet.charAt(Math.floor(Math.random() * characterSet.length));
  }

  return password;
}